import React from "react";

import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { PatientSettings } from "@/pages/patient-settings/PatientSettings.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";

export const PatientSettingsPage: React.FC = () => {
  const styles = useStyles(makeStyles);

  return (
    <PageContent id="patient-settings-page" className={styles.content}>
      <PatientSettings />
    </PageContent>
  );
};

const makeStyles = () => ({
  container: css({}),
  content: css({
    paddingTop: "2vh",
  }),
});
